const convertArrayToString = (data: Array<any>, key: string) => {
  return data
    .map((e: any) => {
      return e[key];
    })
    .toString();
};
export default convertArrayToString;
